module.exports = __webpack_public_path__ + "static/ruby.6deea74b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ruby.svg
// module id = ./src/assets/icons/ruby.svg
// module chunks = 0 1